export default __webpack_public_path__ + "static/niche@992_2x-0bf9af45555dc2e3934eb1acee57ce3e.png";